import React from "react";
import { Stack, Typography, Button, Chip, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
const CustomCard = ({ image, title, tags, onReadMore }) => {
  const navigate = useNavigate();
  const handleReadMore = (card) => {
    navigate("/blog-component");
  };
  return (
    <Stack
      sx={{
        maxWidth: 300,
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        backgroundColor: "#fff",
        // border: "1px solid red",
        height: {
          xl: "400px",
          lg: "356px",
          md: "348px",
          sm: "372px",
          xs: "380px",
        },
        width: {
          xl: "100%",
          lg: "100%",
          md: "100%",
          sm: "100%",
          xs: "100%",
        },
      }}
    >
      {/* Image Section */}
      <Box
        component="img"
        src={image} // Replace with the actual image URL
        alt="Webinar Image"
        sx={{
          width: "100%",
          height: "160px",
          objectFit: "contain",
          //   border: "2px solid red",
        }}
      />

      {/* Content Section */}
      <Stack
        spacing={2}
        sx={{
          padding: "16px",
          //   border: "1px solid blue",
        }}
      >
        {/* Tag */}
        <Chip
          label="Webinar"
          size="small"
          sx={{
            backgroundColor: "#fff4e5",
            color: "#f9a825",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        />

        {/* Title */}
        <Typography
          sx={{
            fontSize: "16px",
            color: "#212121",
            lineHeight: "1.4",
          }}
        >
          {title}
        </Typography>

        {/* Tags */}
        <Stack
          direction="row"
          spacing={1}
          flexWrap="wrap"
          //   sx={{ border: "2px solid red" }}
        >
          {tags.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              size="small"
              sx={{
                backgroundColor: "#f5f5f5",
                color: "#616161",
                fontSize: "12px",
              }}
            />
          ))}
        </Stack>

        {/* Read More Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#ffa726",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "none",
            borderRadius: "20px",
            // border: "2px solid red",
            "&:hover": {
              backgroundColor: "#fb8c00",
            },
          }}
          onClick={onReadMore}
        >
          Read more
        </Button>
      </Stack>
    </Stack>
  );
};

export default CustomCard;
